import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, TextButton } from '@xingternal/button';
import { trackEvent } from '@xingternal/hops-tracking';
import { IconArrowRight } from '@xingternal/icons';

import { useToggleFollowCompany } from '@/domain/job-details/hooks/use-toggle-follow-company';
import { appendQueryParams } from '@/helpers/query-string';
import { redirectUrl } from '@/helpers/redirect-url';
import { useLoginStates } from '@/hooks';

import { CompanyWithLogo } from './employer-types';

import * as S from './employer-actions.styles';

export const EmployerActions: React.FC<{ company: CompanyWithLogo; alignment: 'vertical' | 'horizontal' }> = ({
  company,
  alignment,
}) => {
  const { isLoggedOut } = useLoginStates();
  const { isFollowing, onToggleFollow } = useToggleFollowCompany(company?.id);
  const publicLink = company?.links?.public || '';

  const handleToggleFollow = (event): void => {
    event.stopPropagation();

    const trackFollowEvent = `Event${isFollowing ? 'Unfollow' : 'Follow'}`;
    const PropInteractionType = `jobs_jdp_company_insights_${isFollowing ? 'unfollow' : 'follow'}`;

    trackEvent(trackFollowEvent, { [trackFollowEvent]: 1, PropInteractionType });
    onToggleFollow();
  };

  const jobsURLWithTracking = appendQueryParams(`${publicLink}/jobs`, { sc_o: 'jobs_more_vacancies_link_click' });
  const handleJobsRedirect = (event): void => {
    event.stopPropagation();
    redirectUrl(event, jobsURLWithTracking);
  };

  return (
    <S.ActionsWrapper $alignment={alignment} data-testid={`employer-actions-aligned-${alignment}`}>
      {!isLoggedOut ? (
        <Button variant="secondary" size="small" sizeWide="small" onClick={handleToggleFollow}>
          <FormattedMessage id={`JOBS_COMPANY_INSIGHTS_MODULE_${isFollowing ? 'UNFOLLOW' : 'FOLLOW'}`} />
        </Button>
      ) : null}
      {publicLink ? (
        <TextButton
          size="small"
          icon={IconArrowRight}
          onClick={handleJobsRedirect}
          href={`${publicLink}/jobs`}
          iconAfter
          data-cy="employer-vacancies-link"
        >
          <FormattedMessage id="JOBS_SUGGESTED_NAME_ALL_JOBS" />
        </TextButton>
      ) : null}
    </S.ActionsWrapper>
  );
};
